import trackingEventDictionary from "../../../../../core/dictionary/tracking-event";
import LocalStorageService from "../../../../../core/services/local-storage.service";
import { globalPendoEventForCompanyRedirection } from "../../../../../core/global/global-country-functions";

const IncludeExcludeFilter = ({ includeFilter, excludeFilter, setIncludeFilter }) => {
  const checkPendoEventForCompanyRedirection = (event) => {
    globalPendoEventForCompanyRedirection(event, undefined, undefined, undefined, window.location.pathname, window.location.pathname, LocalStorageService.getUserCurrentPlan());
  };

  const changeSelection = (data) => {
    if (data === "true") {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.open_filter_include_selection);
    } else if (data === "false") {
      checkPendoEventForCompanyRedirection(trackingEventDictionary.open_filter_exclude_selection);
    }
    if (setIncludeFilter) {
      setIncludeFilter(data);
    }
  };
  return (
    <div className="my-3 include-exclude-filter pl-3">
      <div className="d-flex align-items-center">
        <span className="label-md-regular text-capitalize">How would you like to filter the results:</span>
        <div className="custom-right-radio mx-3 d-flex" onChange={(event) => changeSelection(event.target.value)}>
          <div className="form-check px-3">
            <input className="form-check-input" type="radio" name={"inclide-exclude"} id={"include"} value={"true"} defaultChecked={(!includeFilter && !excludeFilter) || includeFilter} />
            <span className="pseudo-checkmark" />
            <label className="form-check-label label-md-regular" htmlFor={"include"}>
              Include Selection
            </label>
          </div>
          <div className="form-check px-3">
            <input className="form-check-input" type="radio" name={"inclide-exclude"} id={"exclude"} value={"false"} defaultChecked={excludeFilter} />
            <span className="pseudo-checkmark" />
            <label className="form-check-label label-md-regular" htmlFor={"exclude"}>
              Exclude Selection
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
export default IncludeExcludeFilter;
